module.exports = {
      id: "arrow-outward-usage",
      viewBox: "0 0 18 18",
      url: "/" + "sprite-a402f8ffc4310bc2e096ed6c94b22ccb.svg#arrow-outward",
      toString: function () {
        return this.url;
      }
    }